import { render, staticRenderFns } from "./flowRequirementForm.vue?vue&type=template&id=573fd69e&"
import script from "./flowRequirementForm.vue?vue&type=script&lang=js&"
export * from "./flowRequirementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports